<template>
    <div>
        <!-- Hero Section -->
        <section class="main-container">
            <div class="container hero-inner">

                <!-- Profile Card -->
                <div class="profile-card">
                    <div class="image-wrapper">
                        <lottie-player :src="require('@/assets/lottie/Proflie Pic - Home.json')"
                            class="ticker-animation" background="transparent" speed="1"
                            style="width: 100%; height: 100%;" loop autoplay>
                        </lottie-player>
                    </div>
                    <div class="profile-content">
                        <p class="small-title">A Senior Animator</p>
                        <h1>Abdul Moin Maroof</h1>
                        <p class="description">
                            I am skilled in animation, illustration, UI/UX, and graphic design.
                        </p>
                    </div>
                    <div class="arrow-btn">
                        <svg width="50" height="40" viewBox="0 0 50 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M30 28.75C30 23.913 26.087 20 21.25 20C26.087 20 30 16.087 30 11.25C30 16.087 33.913 20 38.75 20C33.913 20 30 23.913 30 28.75Z"
                                stroke="#444444" stroke-width="1.25" stroke-miterlimit="10" />
                            <path d="M23.75 20H0" stroke="#444444" stroke-width="1.25" stroke-miterlimit="10" />
                            <path
                                d="M12.5 25.8594C14.9392 33.3452 21.925 38.75 30.1622 38.75C40.428 38.75 48.75 30.3553 48.75 20C48.75 9.64466 40.428 1.25 30.1622 1.25C21.925 1.25 14.9392 6.65485 12.5 14.1406"
                                stroke="#444444" stroke-width="1.25" />
                        </svg>
                    </div>
                </div>

                <!-- Right Section -->
                <div class="right-section">
                    <!-- Ticker -->

                    <div class="featured-banner">
                        <div class="ticker-wrapper">
                            <div class="ticker">
                                <lottie-player :src="require('@/assets/lottie/Featured-banner.json')"
                                    class="ticker-animation" background="transparent" speed="1"
                                    style="width: 100%; height: 100%;" loop autoplay>
                                </lottie-player>
                            </div>
                        </div>
                    </div>

                    <!-- Small Cards Section -->
                    <div class="small-cards">

                        <!-- Signature Card -->
                        <div class="small-card">
                            <lottie-player :src="require('@/assets/lottie/Signature.json')" class="ticker-animation"
                                background="transparent" speed="1" loop autoplay>
                            </lottie-player>
                            <div class="card-text">
                                <p class="subtitle">More about me</p>
                                <h3 class="title">Credentials</h3>
                            </div>
                            <div class="arrow-btn arrow-btn-mobile">
                                <svg width="50" height="40" viewBox="0 0 50 40" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M30 28.75C30 23.913 26.087 20 21.25 20C26.087 20 30 16.087 30 11.25C30 16.087 33.913 20 38.75 20C33.913 20 30 23.913 30 28.75Z"
                                        stroke="#444444" stroke-width="1.25" stroke-miterlimit="10" />
                                    <path d="M23.75 20H0" stroke="#444444" stroke-width="1.25" stroke-miterlimit="10" />
                                    <path
                                        d="M12.5 25.8594C14.9392 33.3452 21.925 38.75 30.1622 38.75C40.428 38.75 48.75 30.3553 48.75 20C48.75 9.64466 40.428 1.25 30.1622 1.25C21.925 1.25 14.9392 6.65485 12.5 14.1406"
                                        stroke="#444444" stroke-width="1.25" />
                                </svg>
                            </div>
                        </div>

                        <!-- Showcase Card -->
                        <div class="small-card">
                            <div class="background-title-wrapper">
                                <h2 class="background-title">MY WORKS</h2>
                            </div>
                            <img src="./../assets/images/showcase.png" alt="Showcase" class="showcase-image" />
                            <div class="card-text">
                                <p class="subtitle">Showcase</p>
                                <h3 class="title">Projects</h3>
                            </div>
                            <div class="arrow-btn arrow-btn-mobile">
                                <router-link to="/works">
                                    <svg width="50" height="40" viewBox="0 0 50 40" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M30 28.75C30 23.913 26.087 20 21.25 20C26.087 20 30 16.087 30 11.25C30 16.087 33.913 20 38.75 20C33.913 20 30 23.913 30 28.75Z"
                                            stroke="#444444" stroke-width="1.25" stroke-miterlimit="10" />
                                        <path d="M23.75 20H0" stroke="#444444" stroke-width="1.25"
                                            stroke-miterlimit="10" />
                                        <path
                                            d="M12.5 25.8594C14.9392 33.3452 21.925 38.75 30.1622 38.75C40.428 38.75 48.75 30.3553 48.75 20C48.75 9.64466 40.428 1.25 30.1622 1.25C21.925 1.25 14.9392 6.65485 12.5 14.1406"
                                            stroke="#444444" stroke-width="1.25" />
                                    </svg>
                                </router-link>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </section>
        <section class="second-section">
            <div class="container">
                <div class="second-section-inner">
                    <!-- Clients Card -->
                    <div class="second-card" style="padding: 0; padding-top: 24px; height: 228px; width: 354px;">
                        <lottie-player :src="require('@/assets/lottie/Client Logo - Home section.json')"
                            class="ticker-animation" background="transparent" speed="1"
                            style="width: 100%; height: 100%;" loop autoplay>
                        </lottie-player>
                        <div class="second-card-text" style="padding-left: 24px;padding-bottom: 24px;">
                            <p class="second-card-subtitle" style="margin-top: 0;">Working with</p>
                            <h3 class="second-card-title">Clients</h3>
                        </div>
                        <div class="arrow-btn arrow-btn-mobile">
                            <svg width="50" height="40" viewBox="0 0 50 40" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M30 28.75C30 23.913 26.087 20 21.25 20C26.087 20 30 16.087 30 11.25C30 16.087 33.913 20 38.75 20C33.913 20 30 23.913 30 28.75Z"
                                    stroke="#444444" stroke-width="1.25" stroke-miterlimit="10" />
                                <path d="M23.75 20H0" stroke="#444444" stroke-width="1.25" stroke-miterlimit="10" />
                                <path
                                    d="M12.5 25.8594C14.9392 33.3452 21.925 38.75 30.1622 38.75C40.428 38.75 48.75 30.3553 48.75 20C48.75 9.64466 40.428 1.25 30.1622 1.25C21.925 1.25 14.9392 6.65485 12.5 14.1406"
                                    stroke="#444444" stroke-width="1.25" />
                            </svg>
                        </div>
                    </div>

                    <!-- Services Offering Card -->
                    <div class="services-card">
                        <div class="services-icons">
                            <div>
                                <lottie-player :src="require('@/assets/lottie/Illustration-service icon.json')"
                                    class="ticker-animation" background="transparent" speed="1" loop
                                    autoplay></lottie-player>
                                <p class="services-subtitle">Illustrations</p>
                            </div>
                            <div>
                                <lottie-player :src="require('@/assets/lottie/3D-service icon.json')"
                                    class="ticker-animation" background="transparent" speed="1" loop
                                    autoplay></lottie-player>
                                <p class="services-subtitle">3D</p>
                            </div>
                            <div>
                                <lottie-player :src="require('@/assets/lottie/Branding.json')" class="ticker-animation"
                                    background="transparent" speed="1" loop autoplay></lottie-player>
                                <p class="services-subtitle">Branding</p>
                            </div>
                            <div>
                                <lottie-player :src="require('@/assets/lottie/Animation-service icon.json')"
                                    class="ticker-animation" background="transparent" speed="1" loop
                                    autoplay></lottie-player>
                                <p class="services-subtitle">Animation</p>
                            </div>
                        </div>
                        <h3 class="services-title">Services offering</h3>
                    </div>
                    <!-- Projects Card -->
                    <div class="second-card">
                        <div class="services-icons" style="gap: 24px; margin: 20px auto;">
                            <a href="https://dribbble.com/Moin-98" target="_blank">
                                <svg width="114" height="114" viewBox="0 0 114 114" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M30.4004 0.5H83.5996C100.113 0.5 113.5 13.8871 113.5 30.4004V83.5996C113.5 100.113 100.113 113.5 83.5996 113.5H30.4004C13.8871 113.5 0.5 100.113 0.5 83.5996V30.4004C0.5 13.8871 13.8871 0.5 30.4004 0.5Z"
                                        fill="#F5F3EF" fill-opacity="0.02" />
                                    <path
                                        d="M30.4004 0.5H83.5996C100.113 0.5 113.5 13.8871 113.5 30.4004V83.5996C113.5 100.113 100.113 113.5 83.5996 113.5H30.4004C13.8871 113.5 0.5 100.113 0.5 83.5996V30.4004C0.5 13.8871 13.8871 0.5 30.4004 0.5Z"
                                        stroke="url(#paint0_linear_33_87)" />
                                    <circle cx="57" cy="57" r="21" stroke="white" stroke-width="2" />
                                    <path d="M36 54.5C44.5 55 63.6 53.2 72 42" stroke="white" stroke-width="2" />
                                    <path d="M78 58.5C70.3333 56 52.5 55.3 42.5 72.5" stroke="white" stroke-width="2" />
                                    <path d="M49.5 37C54.1667 42.8333 64.1 58.8 66.5 76" stroke="white"
                                        stroke-width="2" />
                                    <defs>
                                        <linearGradient id="paint0_linear_33_87" x1="1.10145" y1="4.6594" x2="132.761"
                                            y2="48.8175" gradientUnits="userSpaceOnUse">
                                            <stop stop-color="#262626" />
                                            <stop offset="1" stop-color="#2C2C2C" />
                                        </linearGradient>
                                    </defs>
                                </svg>

                            </a>
                            <a href="https://www.behance.net/abdulmoinmaroof" target="_blank">
                                <svg width="114" height="114" viewBox="0 0 114 114" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M30.4004 0.5H83.5996C100.113 0.5 113.5 13.8871 113.5 30.4004V83.5996C113.5 100.113 100.113 113.5 83.5996 113.5H30.4004C13.8871 113.5 0.5 100.113 0.5 83.5996V30.4004C0.5 13.8871 13.8871 0.5 30.4004 0.5Z"
                                        fill="#F5F3EF" fill-opacity="0.02" />
                                    <path
                                        d="M30.4004 0.5H83.5996C100.113 0.5 113.5 13.8871 113.5 30.4004V83.5996C113.5 100.113 100.113 113.5 83.5996 113.5H30.4004C13.8871 113.5 0.5 100.113 0.5 83.5996V30.4004C0.5 13.8871 13.8871 0.5 30.4004 0.5Z"
                                        stroke="url(#paint0_linear_33_99)" />
                                    <path
                                        d="M52.3851 55.8943C52.3851 55.8943 56.6939 55.5719 56.6939 50.5217C56.6939 45.4714 53.1695 43 48.6995 43H34V71.2492H48.6995C48.6995 71.2492 57.6717 71.5286 57.6717 62.9109C57.6717 62.9109 58.0585 55.8943 52.3851 55.8943ZM40.4794 48.0073H48.6995C48.6995 48.0073 50.6981 48.0073 50.6981 50.9515C50.6981 53.8957 49.5268 54.3147 48.1944 54.3147H40.4794V48.0073ZM48.3234 66.2204H40.4794V58.6665H48.6995C48.6995 58.6665 51.6759 58.6343 51.6759 62.5456C51.6759 65.8121 49.4946 66.1774 48.3234 66.2204Z"
                                        fill="white" />
                                    <path d="M75.2289 44.6548H63.5703V48.1362H75.2289V44.6548Z" fill="white" />
                                    <path
                                        d="M69.6415 50.1777C58.7781 50.1777 58.7888 61.0304 58.7888 61.0304C58.7888 61.0304 58.0474 71.8294 69.6415 71.8294C69.6415 71.8294 79.3122 72.3881 79.3122 64.3184H74.3372C74.3372 64.3184 74.4983 67.3593 69.8027 67.3593C69.8027 67.3593 64.8276 67.6925 64.8276 62.4488H79.4626C79.4626 62.4488 81.0637 50.1885 69.6308 50.1885L69.6415 50.1777ZM64.7847 58.6665C64.7847 58.6665 65.3864 54.3147 69.7597 54.3147C74.133 54.3147 74.0685 58.6665 74.0685 58.6665H64.7847Z"
                                        fill="white" />
                                    <defs>
                                        <linearGradient id="paint0_linear_33_99" x1="1.10145" y1="4.6594" x2="132.761"
                                            y2="48.8175" gradientUnits="userSpaceOnUse">
                                            <stop stop-color="#262626" />
                                            <stop offset="1" stop-color="#2C2C2C" />
                                        </linearGradient>
                                    </defs>
                                </svg>

                            </a>
                        </div>
                        <div class="second-card-text">
                            <p class="second-card-subtitle">Stay with me</p>
                            <h3 class="second-card-title">Projects</h3>
                        </div>
                        <div class="arrow-btn arrow-btn-mobile">
                            <router-link to="/works">
                                <svg width="50" height="40" viewBox="0 0 50 40" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M30 28.75C30 23.913 26.087 20 21.25 20C26.087 20 30 16.087 30 11.25C30 16.087 33.913 20 38.75 20C33.913 20 30 23.913 30 28.75Z"
                                        stroke="#444444" stroke-width="1.25" stroke-miterlimit="10" />
                                    <path d="M23.75 20H0" stroke="#444444" stroke-width="1.25" stroke-miterlimit="10" />
                                    <path
                                        d="M12.5 25.8594C14.9392 33.3452 21.925 38.75 30.1622 38.75C40.428 38.75 48.75 30.3553 48.75 20C48.75 9.64466 40.428 1.25 30.1622 1.25C21.925 1.25 14.9392 6.65485 12.5 14.1406"
                                        stroke="#444444" stroke-width="1.25" />
                                </svg>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <div class="container">
            <section class="stats-cta-container">
                <!-- Stats Card -->
                <div class="stats-card">
                    <div class="stat">
                        <h2>07+</h2>
                        <p>Years<br class="line-break" /> Experience</p>
                    </div>
                    <div class="stat">
                        <h2>50+</h2>
                        <p>Clients<br class="line-break" /> Worldwide</p>
                    </div>
                    <div class="stat">
                        <h2>80+</h2>
                        <p>Total<br class="line-break" /> Projects</p>
                    </div>
                </div>

                <!-- CTA Card -->
                <div class="cta-card">
                    <div class="cta-decoration">
                        <img src="./../assets/images/second-arrow.png" alt="Decoration" />
                    </div>
                    <div class="cta-text">
                        <h2>Let’s</h2>
                        <h2>work <span>together.</span></h2>
                    </div>
                    <div class="arrow-btn arrow-btn-mobile button-display">
                        <router-link to="/contact">
                            <svg width="50" height="40" viewBox="0 0 50 40" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M30 28.75C30 23.913 26.087 20 21.25 20C26.087 20 30 16.087 30 11.25C30 16.087 33.913 20 38.75 20C33.913 20 30 23.913 30 28.75Z"
                                    stroke="#444444" stroke-width="1.25" stroke-miterlimit="10" />
                                <path d="M23.75 20H0" stroke="#444444" stroke-width="1.25" stroke-miterlimit="10" />
                                <path
                                    d="M12.5 25.8594C14.9392 33.3452 21.925 38.75 30.1622 38.75C40.428 38.75 48.75 30.3553 48.75 20C48.75 9.64466 40.428 1.25 30.1622 1.25C21.925 1.25 14.9392 6.65485 12.5 14.1406"
                                    stroke="#444444" stroke-width="1.25" />
                            </svg>
                        </router-link>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>

export default {
    name: 'LandingPage',
}
</script>

<style scoped>
/* ===================== Navbar Section ===================== */

/* ===================== Hero Section ===================== */
.main-container {
    padding-top: 85px;
    margin-top: 40px;
}

.hero-inner {
    display: flex;
    gap: 20px;
    align-items: flex-start;
}

/* ===================== Profile Card ===================== */
.profile-card {
    width: 623px;
    height: 368px;
    background: linear-gradient(109deg, #1d1d1d 0%, #121212 100%);
    border-radius: 32px;
    position: relative;
    overflow: hidden;
    border: 1px solid #2c2c2c;
}

.image-wrapper {
    width: 252px;
    height: 254px;
    border-top-left-radius: 32px;
    border-bottom-right-radius: 32px;
    position: absolute;
    top: 56px;
    left: 56px;
    overflow: hidden;
}

.image-wrapper img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.profile-content {
    position: absolute;
    top: 56px;
    left: 340px;
    display: flex;
    flex-direction: column;
}

.small-title {
    font-size: 18px;
    font-weight: 300;
    color: #444444;
    margin-bottom: 10px;
}

.profile-content h1 {
    font-size: 40px;
    font-weight: 500;
    color: #f5f3ef;
    margin-bottom: 0;
    margin-top: 0;
}

.description {
    font-size: 18px;
    font-weight: 300;
    color: #444444;
    width: 240px;
    line-height: 140%;
}

.arrow-btn {
    position: absolute;
    right: 30px;
    bottom: 30px;
    width: 45px;
    height: 45px;
    z-index: 2;
}

.arrow-btn:hover {
    cursor: pointer;
}


.arrow-btn svg:hover path {
    stroke: #ffffff;
    cursor: pointer;
}

.arrow-btn svg path {
    transition: stroke 0.3s ease;
}

.arrow-btn img {
    width: 100%;
}

/* ===================== Right Section ===================== */
.right-section {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 540px;
}

/* Featured Banner */
.featured-banner {
    position: relative;
    width: 600px;
    border-radius: 32px;
    overflow: hidden;
    border: 1px solid transparent;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* ===================== Small Cards ===================== */
.small-cards {
    display: flex;
    gap: 20px;
    width: 600px;
}

/* Small Card (Common) */
.small-card {
    width: 300px;
    height: 228px;
    background: linear-gradient(109deg, #1d1d1d 0%, #121212 100%);
    border-radius: 32px;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    padding: 30px;
    border: 1px solid #2c2c2c;
}

/* Signature Card */
.signature-image {
    width: 180px;
    height: auto;
    object-fit: contain;
    margin-bottom: auto;
    margin-top: 30px;
}

/* Showcase Card */
.showcase-image {
    width: 220px;
    object-fit: contain;
    margin-bottom: auto;
    margin-top: 15px;
    z-index: 2;
    position: relative;
}

.background-title-wrapper {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    text-align: center;
    pointer-events: none;
    z-index: 0;
}

.background-title {
    font-size: 36px;
    font-weight: 700;
    margin-top: 25px;
    color: rgba(255, 255, 255, 0.07);
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0.416), rgba(255, 255, 255, 0));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

/* Text inside Cards */
.card-text {
    width: 100%;
    text-align: left;
    /* margin-top: 20px; */
    z-index: 2;
}

.subtitle {
    font-size: 18px;
    color: #444444;
    font-weight: 300;
    margin-bottom: 4px;
}

.title {
    font-size: 24px;
    font-weight: 400;
    color: #f5f3ef;
    margin: 0;
}

/* Arrow Icon */
.arrow-small {
    position: relative;
    right: 20px;
    bottom: 20px;
    width: 24px;
    height: 24px;
    z-index: 2;
}

.arrow-small img {
    width: 100%;
}

.second-section {
    margin-top: 20px;
}

/* Single Card */

.second-card {
    width: 300px;
    height: 204px;
    background: linear-gradient(109deg, #1d1d1d 0%, #121212 100%);
    border-radius: 32px;
    padding: 24px;
    position: relative;
    overflow: hidden;
    border: 1px solid #2c2c2c;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
}

.second-card img {
    /* width: 140px; */
    object-fit: contain;
    margin: 0 auto;
    opacity: 0.6;
}

.second-card-text {
    width: 100%;
}

.second-card-subtitle {
    font-size: 18px;
    font-weight: 300;
    color: #444444;
    margin-bottom: 4px;
}

.second-card-title {
    font-size: 24px;
    font-weight: 400;
    color: #f5f3ef;
    margin-top: 0;
    margin-bottom: 0;
}

/* ========== Services Offering Card (Middle One Special) ========== */
.services-card {
    width: 749px;
    height: 204px;
    background: linear-gradient(109deg, #1d1d1d 0%, #121212 100%);
    border-radius: 32px;
    padding: 24px;
    position: relative;
    overflow: hidden;
    border: 1px solid #2c2c2c;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
}

.services-icons {
    display: flex;
    justify-content: center;
    gap: 25px;
    /* margin-bottom: 50px; */
}

.services-icons .services-subtitle {
    margin-bottom: 25px;
    margin-top: -5px;
    text-align: center;
}

.ticker-animation {
    height: auto;
}

.nimation {
    height: auto;
}

.services-icons svg {
    width: 90px;
    height: 90px;
    margin-bottom: 10px;
    object-fit: contain;
}

.services-text {
    width: 100%;
}

.services-subtitle {
    font-size: 18px;
    font-weight: 300;
    color: #444444;
    margin-bottom: 4px;
}

.services-title {
    font-size: 24px;
    font-weight: 500;
    color: #f5f3ef;
    margin-top: 0;
    margin-bottom: 0;
}

.arrow-small {
    position: absolute;
    right: 20px;
    bottom: 20px;
    width: 24px;
    height: 24px;
    z-index: 3;
}

.arrow-small img {
    width: 100%;
}

.second-section-inner {
    display: flex;
    gap: 20px;
    justify-content: center;
    /* Center the cards inside container */
}

/*Stats cta Container */
.stats-cta-container {
    display: flex;
    gap: 20px;
    margin-top: 20px;
    margin-bottom: 85px;
}

/* Stats Card */
.stats-card {
    flex: 1;
    background: linear-gradient(109deg, #1d1d1d 0%, #121212 100%);
    border-radius: 32px;
    padding: 30px;
    display: flex;
    gap: 20px;
    justify-content: space-around;
    align-items: center;
    border: 1px solid #2c2c2c;
}

.stat {
    text-align: center;
    background: #1d1d1d;
    border-radius: 32px;
    border: 1px solid #2c2c2c;
    width: 165px;
    height: 176px;
}

.stat h2 {
    font-size: 40px;
    color: #f5f3ef;
    font-weight: 500;
    margin-bottom: 14px;
}

.stat p {
    font-size: 18px;
    color: #444444;
    font-weight: 300;
    line-height: 1.3;
    margin: 0;

}

.stats-section {
    display: flex;
    gap: 20px;
}

.stat-card {
    background: rgba(245, 243, 239, 0.02);
    border: 1px solid #2c2c2c;
    border-radius: 24px;
    width: 110px;
    height: 130px;
    padding: 16px;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.stat-card h3 {
    font-size: 28px;
    font-weight: 600;
    color: #ffffff;
    margin-bottom: 10px;
}

.stat-card p {
    font-size: 14px;
    font-weight: 300;
    color: #444444;
    line-height: 1.2;
}

/* CTA Card */
.cta-card {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background: linear-gradient(109deg, #1d1d1d 0%, #121212 100%);
    border-radius: 32px;
    border: 1px solid #2c2c2c;
    padding: 40px;
    height: 160px;
    /* Match with left stat cards */
    position: relative;
    flex: 1;
}

/* Top decoration */
.cta-decoration {
    position: absolute;
    top: 0;
    left: 45px;
    z-index: 1;
}

.cta-decoration img {
    height: 72px;
    opacity: 0.7;
}

/* Text block aligned to bottom */
.cta-text {
    margin-top: 53px;
    z-index: 2;
}

.cta-text h2 {
    font-size: 48px;
    font-weight: 500;
    margin: 0;
    line-height: 120%;
    color: white;
}

.cta-text h2 span {
    color: #F63E02;
}

/* Arrow bottom-right */
.arrow-small {
    position: absolute;
    right: 24px;
    bottom: 24px;
    width: 24px;
    height: 24px;
}

.arrow-small img {
    width: 100%;
}

.small-card lottie-player {
    width: 100%;
    height: 100%;
}

/* ========== Responsive Design ========== */

/* Tablets: 768px to 1023px */
@media (max-width: 1023px) {

    .hero-inner,
    .second-section-inner,
    .stats-cta-container {
        flex-direction: column;
        align-items: center;
    }

    .main-container,
    .second-section,
    .stats-cta-container,
    .container {
        padding-left: 24px;
        padding-right: 24px;
    }

    .profile-card,
    .right-section,
    .small-cards,
    .second-card,
    .services-card,
    .stats-card,
    .cta-card {
        width: 100% !important;
        max-width: 100%;
        box-sizing: border-box;
    }

    .right-section {
        align-items: center;
    }

    .small-cards {
        flex-direction: column;
        align-items: center;
        gap: 20px;
    }

    .second-section-inner {
        gap: 24px;
    }

    .services-card {
        height: auto;
    }

    .services-icons {
        flex-wrap: wrap;
        gap: 24px;
        justify-content: center;
    }

    .cta-card {
        height: auto;
        padding: 30px;
    }

    .cta-text h2 {
        font-size: 32px;
    }

    .arrow-small {
        right: 16px;
        bottom: 16px;
    }
}

/* Mobiles: 767px and below */
@media (max-width: 767px) {

    .main-container,
    .second-section,
    .stats-cta-container,
    .container {
        padding-left: 10px;
        padding-right: 10px;
    }

    .hero-inner,
    .small-cards,
    .second-section-inner,
    .stats-cta-container {
        flex-direction: column;
        gap: 16px;
        align-items: center;
    }

    .profile-card {
        height: auto;
        flex-direction: column;
        padding-top: 30px;
    }

    .image-wrapper {
        position: relative;
        margin: 0 auto;
        margin-top: 30px;
        top: unset;
        left: unset;
    }

    .profile-content {
        position: relative;
        left: unset;
        top: unset;
        align-items: center;
        text-align: center;
        padding: 0 10px;
    }

    .arrow-btn {
        position: relative;
        margin: 0 auto 20px auto;
        bottom: unset;
        right: unset;
    }

    .arrow-btn-mobile {
        position: absolute;
        right: 16px;
        bottom: 16px;
        margin: 0;
    }

    .button-display {
        display: none;
    }

    .featured-banner {
        width: 100%;
        height: auto;
        margin-left: 16px;
        margin-right: 16px;
    }

    .small-card,
    .second-card,
    .services-card,
    .stats-card,
    .cta-card {
        width: 100% !important;
        box-sizing: border-box;
        padding: 24px;
    }

    .services-icons svg {
        width: 114px;
        height: 114px;
    }

    .stats-card {
        display: flex;
        flex-direction: column;
        gap: 16px;
        padding: 25px 20px;
        box-sizing: border-box;
    }

    .stat {
        display: flex;
        align-items: center;
        gap: 25px;
        padding: 16px 20px;
        background: rgba(44, 44, 44, 0.325);
        border-radius: 24px;
        width: 100%;
        height: 101px;
        max-width: 100%;
        box-sizing: border-box;
    }

    .stat h2 {
        font-size: 40px;
        color: white;
        margin: 0;
        font-weight: 500;

    }

    .stat p {
        font-size: 18px;
        color: #444444;
    }

    .cta-text {
        margin-top: 93px;
    }

    .cta-text h2 {
        font-size: 40px;
        font-weight: 500;
    }

    .arrow-small {
        right: 16px;
        bottom: 16px;
    }

    .background-title {
        margin-top: 5px;
        font-size: 40px;
    }

    .subtitle,
    .second-card-subtitle,
    .services-subtitle {
        font-size: 14px;
    }

    .title,
    .second-card-title,
    .services-title {
        font-size: 20px;
    }

    .cta-text h2 span {
        font-size: inherit;
    }

    .profile-content {
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .small-title {
        margin-top: 10px;
        margin-bottom: 10px;
        font-size: 18px;
    }

    .profile-content h1 {
        font-size: 40px;
        margin-bottom: 10px;
    }

    .description {
        font-size: 18px;
        font-weight: 300;
        color: #444444;
        line-height: 140%;
        width: auto;
        padding: 0 20px;
        margin: 10px 0;
    }

    /* Fix padding and spacing on card titles */
    .card-text {
        margin-top: 12px;
    }

    .subtitle,
    .second-card-subtitle,
    .services-subtitle {
        font-size: 18px;
        margin-bottom: 2px;
    }

    .title,
    .second-card-title,
    .services-title {
        font-size: 24px;
        line-height: 1.3;
    }

    .second-card {
        height: 282px;
    }

    /* Fix image and background title layering */
    .background-title-wrapper {
        margin-top: 18px;
        z-index: 0;
    }

    .showcase-image {
        position: absolute;
        top: 28px;
        z-index: 2;
    }

    /* Two icons per row for Services */
    .services-icons {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        justify-items: center;
        gap: 0;
        margin-bottom: 15px;
    }

    .services-icons svg {
        width: 114px;
        height: 114px;
        object-fit: contain;
        opacity: 0.8;
    }

    /* .cta-card {
        padding-top: 80px;
    } */
    .cta-decoration {
        left: 25px;
    }

    .cta-decoration img {
        height: 86px;
        width: 37px;
    }

    .line-break {
        display: none;
    }

    .small-card lottie-player {
        width: 80%;
        height: 80%;
    }

    .small-card {
        height: 265px;
    }

    .second-card-title {
        margin-bottom: 0;
    }
}
</style>